import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PostHogProvider, PostHogErrorBoundary } from '@posthog/react';
import { AlertCircle } from 'lucide-react';

const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com',
  autocapture: false,
  capture_pageview: true,
  capture_pageleave: true,
};

const ErrorFallback = ({ error, componentStack }) => (
  <div className="min-h-screen bg-white flex items-center justify-center p-4">
    <div className="max-w-md w-full bg-white rounded-xl shadow-lg border border-slate-200 p-8">
      <div className="flex flex-col items-center text-center space-y-4">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
          <AlertCircle size={32} className="text-red-600" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">
          Something went wrong
        </h1>
        <p className="text-slate-600">
          We've logged this error and will look into it. Please try refreshing the page.
        </p>
        {process.env.NODE_ENV === 'development' && error && (
          <details className="w-full text-left bg-slate-50 rounded-lg p-4 text-xs">
            <summary className="cursor-pointer font-semibold text-slate-700 mb-2">
              Error Details (dev only)
            </summary>
            <pre className="whitespace-pre-wrap text-red-600 mb-2">
              {error.toString()}
            </pre>
            {componentStack && (
              <pre className="whitespace-pre-wrap text-slate-600">
                {componentStack}
              </pre>
            )}
          </details>
        )}
        <button
          onClick={() => window.location.href = '/'}
          className="px-6 py-3 bg-primary text-white font-semibold rounded-xl hover:bg-dark transition-colors cursor-pointer"
        >
          Return to Home
        </button>
      </div>
    </div>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider 
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={posthogOptions}
    >
      <PostHogErrorBoundary fallback={ErrorFallback}>
        <App />
      </PostHogErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>
);
